<template>
	<div class="c-editor-charts">
		<div v-if="!loading" v-for="chart in charts">
			<div v-if="$route.params.chartid == chart.id">

				<div class="c-editor-charts__editablebar" :class="{ 'margin-top-large': !((chart.fields['background-image'] && chart.fields['background-image'].permissions.can_edit) || (chart.fields['background-video'] && chart.fields['background-video'].permissions.can_edit))}">

					<div v-if="chart.fields['background-image'] && chart.fields['background-image'].permissions.can_edit" class="c-editor-charts__editable">
						<v-editable :chartid="chart.id" :icon="'picture-o'" :areaedit="false" :fieldname="'background-image'"></v-editable>
					</div>

					<div v-if="chart.fields['background-video'] && chart.fields['background-video'].permissions.can_edit" class="c-editor-charts__editable">
						<v-editable :chartid="chart.id" :icon="'video-camera'" :areaedit="false" :name="'background-video'"></v-editable>
					</div>

				</div>

				<div
				v-if="chart_component_exists('v-chart-' + chart.component)"

				:is="'v-chart-' + chart.component"
				:data="chart"
				:key="chart.id"></div>

				<v-field
				 	v-for="(field, name) in chart.fields"
	                v-if="active_field.fieldname == name && !$store.getters['features/inlinemod']"

	                :chart="chart"
	                :name="name"
	                :key="name"
	                @cancel="$store.commit('RESET_ACTIVE_FIELD')"
	            ></v-field>

			</div>
		</div>
	</div>
</template>

<script>


import Vue from 'vue';

function flatenCharts(charts){
	let out = {};
	Object.keys(charts).forEach(function(key){
		let chart = charts[key]
		if(!out[chart.id]) Vue.set(out, chart.id, chart);
		if(chart.charts) out = Object.assign({}, out, flatenCharts(chart.charts));
	});

	return out;
}

export default {
	name: 'c-editor-charts',
	props: ['chartid'],
	methods: {
		chart_component_exists(chartname){
			const ccexists = (this.$store.getters.chartcomponents.indexOf(chartname) >= 0);
			if(!ccexists) console.info('chart component dosent exists', chartname)
			return ccexists;
		},
	},
	computed: {
		active_field(){
			return this.$store.getters.active_field;
		},
		loading(){
			return this.$store.getters.loading;
		},
		charts(){
			const charts = flatenCharts(this.$store.getters.charts);
			return charts;
		},
	},
}
</script>

<style scoped>
	.c-editor-charts__editablebar {
		display: block;
		padding: 0 1em;
	}
	.c-editor-charts__editable {
		display: inline-block;
		position: relative;
		min-width: 30px;
	}
</style>



// WEBPACK FOOTER //
// src/components/p-editor/c-editor-charts.vue